import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput, RadioInput } from '../../components/common/components'
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';





export default function SchdType() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const [schdId, setSchdId] = useState("")

    const dispatch = useDispatch()

    let history = useHistory();

    const handleNextClick = () => {
        window.location.href = `./second_step?schd_type=${schdId}&src=first_step`
        // history.push(`/second_step?schd_type=${schdId}`)
    }

    if (option.schd_type.length === 0) {
        return <div>loading...</div>
    }

    let schdTypeData = _.find(option.schd_type, (o) => {
        return o.value === schdId
    })

    const handleSchdIdChange = (field, val) => {
        // console.log(field, val);
        setSchdId(val)
    }


    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>

            <RadioInput
                label="預約類別"
                field="schdId"
                value={schdId}
                options={option.schd_type}
                setValue={handleSchdIdChange}
            />
            <p style={{ paddingLeft: "30px", letterSpacing: 0, margin: 0, lineHeight: "1.5" }}>
                免費篩檢報名資格
                <br /><br />
                1.乳癌：45-69歲或40-44歲二等血親內曾罹患乳癌的女性，每2年1次乳房攝影檢查。<br />
                2.肺癌：有肺癌家族史或重度吸菸史者提供低劑量電腦斷層檢查<br />
                *肺癌家族史：50至74歲男性或45至74歲女性，且其父母、子女或兄弟姊妹經診斷為肺癌之民眾。若有吸菸情形，應同意接受戒菸服務。(報名需填寫肺癌家人之姓名、身分證號碼、出生年月日)。<br />
                *重度吸菸史：50至74歲吸菸史達30 (抽菸每日包數*年)以上，有意願戒菸（若有吸菸情形，應同意接受戒菸服務）或戒菸15年內之重度吸菸者。<br />
                3.大腸癌：50至75歲，每2年1次糞便潛血檢查。<br />
                4.口腔癌：30歲以上有嚼檳榔(含已戒)或吸菸者、18歲以上有嚼檳榔(含已戒)原住民，每2年1次口腔黏膜檢查。<br />
                5.子宮頸癌：30歲以上婦女每年1次抹片檢查。<br />
                6.成人預防保健：40-64歲每三年一次；65歲以上，每年一次。<br /><br />
                自費胃癌篩檢  費用450元，<a href='https://www.kfsyscc.org/m/hp-tes' rel="noreferrer" target={"_blank"}>了解更多資訊</a>



            </p>
            <div  style={{marginLeft:"30px"}}>
            {/* <Table>
                <TableHead>
                    <TableRow>                       
                        <TableCell colSpan={2} align="center">服務時間</TableCell>	 
                        <TableCell align="center">報名地點</TableCell>	 
                        <TableCell align="center">肺癌</TableCell>	 
                        <TableCell align="center">乳癌</TableCell>	 
                        <TableCell align="center">大腸癌</TableCell>	 
                        <TableCell align="center">口腔癌</TableCell>	 
                        <TableCell align="center">子宮頸癌</TableCell>	
                        <TableCell align="center">成人預防保健</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell rowSpan={3} align="center">周一至週五</TableCell>
                        <TableCell align="center">0900-1600</TableCell>
                        <TableCell align="center">B1中央櫃台</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell rowSpan={3} align="center">抹片檢查，請掛本院婦科門診</TableCell>
                        <TableCell align="center">V</TableCell>
                    </TableRow> 
                    <TableRow>
                        <TableCell align="center">0900-1200</TableCell>
                        <TableCell align="center">B1婦女門診</TableCell>
                        <TableCell></TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow> 
                    <TableRow>
                        <TableCell align="center">1300-1600</TableCell>
                        <TableCell align="center">3F大健康中心</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                        <TableCell align="center">V</TableCell>
                    </TableRow> 
                </TableBody>
            </Table> */}
            </div>
           






            {option.loading ?
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress size={200} />
                </div> : null}
        </Paper>
        {option.loading ? null : <>
            {!schdTypeData || schdTypeData.isActive === "N" ? null : <Button
                variant="contained"
                color="primary"
                style={{ margin: "30px auto" }}
                onClick={() => { handleNextClick() }}
            >
                下一步
            </Button>}
        </>
        }
    </Box>
}